import { Input } from "@/components/ui/input";
import { inr, dmy } from "@/lib/proforma";

export function PILines({ lines, sectionTitle, onSection, onLine }) {
  let sno = 0, last = null;
  return (
    <div className="overflow-x-auto rounded-lg border border-slate-200" data-testid="pi-lines">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-[11px] uppercase tracking-wide text-slate-500">
          <tr>{["S.No.", "Invoice No", "Date", "Description", "Qty", "Rate (INR)", "Amount (INR)", "GST"].map((h) => <th key={h} className="px-3 py-2 text-left font-semibold">{h}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          <tr><td colSpan={8} className="px-3 py-1.5">
            <Input value={sectionTitle} onChange={(e) => onSection(e.target.value)} placeholder="Section title (optional), e.g. CONSIGNMENT HR SLITTING LINE"
              className="h-8 text-sm font-semibold" data-testid="pi-section-title" />
          </td></tr>
          {lines.map((l, i) => {
            const first = l.invoice_no !== last;
            if (first) { sno += 1; last = l.invoice_no; }
            return (
              <tr key={`${l.invoice_no}-${i}`} className={first ? "border-t border-slate-200" : ""} data-testid={`pi-line-${i}`}>
                <td className="px-3 py-1.5 text-slate-500">{first ? sno : ""}</td>
                <td className="px-3 py-1.5 font-mono text-slate-900">{first ? l.invoice_no : ""}</td>
                <td className="px-3 py-1.5 text-slate-500">{first ? dmy(l.date) : ""}</td>
                <td className="px-3 py-1"><Input value={l.description} onChange={(e) => onLine(i, e.target.value)} className="h-7 text-sm" data-testid={`pi-line-desc-${i}`} /></td>
                <td className="px-3 py-1.5 tabular-nums">{l.qty} {l.unit}</td>
                <td className="px-3 py-1.5 tabular-nums text-right">{inr(l.rate)}</td>
                <td className="px-3 py-1.5 tabular-nums text-right font-medium">{inr(l.amount)}</td>
                <td className="px-3 py-1.5 text-xs text-slate-500">{l.gst_rate}%</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
